import catalog from '../../../config/notification-catalog.json';
export const notificationCatalog=catalog;
export type NoticeTone=keyof typeof catalog.tones;
export type NoticeEntry=typeof catalog.entries[number];
const entries=new Map(catalog.entries.map(entry=>[entry.key,entry]));
export function noticeTone(key?:string,fallback:NoticeTone='info'):NoticeTone{
 return (key&&entries.get(key)?.tone as NoticeTone)||fallback;
}
export const noticeTokenKeys=Object.keys(catalog.tones).flatMap(tone=>['surface','text','accent'].map(part=>'--notice-'+tone+'-'+part));
export function noticeCopyProblem(entry:NoticeEntry,text:string){
 const variables=[...new Set([...text.matchAll(/\{(\w+)\}/g)].map(match=>match[1]))];
 if(!text.trim())return 'Bildirim metni boş olamaz.';
 if(text.length>1000)return 'En fazla 1000 karakter yazabilirsiniz.';
 if(variables.length!==entry.variables.length||variables.some(v=>!entry.variables.includes(v))||/[{}]/.test(text.replace(/\{\w+\}/g,'')))
  return 'Gerekli değişkenleri koruyun: '+(entry.variables.map(v=>'{'+v+'}').join(', ')||'Bu metin değişken kullanmaz.');
 return '';
}
export function noticePreviewText(text:string){
 return text.replace(/\{(\w+)\}/g,(match,key)=>(catalog.examples as Record<string,string|number>)[key]?.toString()??match);
}
